"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[917],{

/***/ 7963:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ Logo; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9521);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _providers_ConfigContextProvider__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5547);
/* harmony import */ var _ui_LabElement__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7656);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  gap: 0.3em;\n  flex-direction: ",
        ";\n\n  transition: filter 0.3s, color var(--transition-speed-link);\n\n  &:active {\n    color: var(--hc);\n  }\n\n  @media (any-pointer: fine) {\n    &:hover {\n      color: var(--hc);\n\n      div {\n        color: var(--hc) !important;\n        border-color: var(--hc) !important;\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var LogoLink = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].a.withConfig */ .ZP.a.withConfig({
    componentId: "sc-d8c22dc5-0"
})(_templateObject(), function(param) {
    var direction = param.direction;
    return direction === "vertical" ? "column" : "row";
});
var Logo = function(param) {
    var color = param.color, hoverColor = param.hoverColor, size = param.size, direction = param.direction;
    var config = (0,_providers_ConfigContextProvider__WEBPACK_IMPORTED_MODULE_4__/* .useConfigContext */ .q)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
        className: "logo",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
            href: "".concat(config === null || config === void 0 ? void 0 : config.baseUrl, "/"),
            passHref: true,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(LogoLink, {
                direction: direction,
                title: "Go to homepage",
                style: {
                    "--hc": hoverColor !== null && hoverColor !== void 0 ? hoverColor : "var(--color-ailab-red)"
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_ui_LabElement__WEBPACK_IMPORTED_MODULE_5__/* .LabElement */ .c, {
                        shortHandle: "PI",
                        longText: "Public Interest",
                        color: color,
                        size: size
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_ui_LabElement__WEBPACK_IMPORTED_MODULE_5__/* .LabElement */ .c, {
                        shortHandle: "AI",
                        longText: "AI",
                        color: color,
                        size: size
                    })
                ]
            })
        })
    });
};


/***/ }),

/***/ 7051:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ MatomoUserTracking; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4298);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _providers_ConfigContextProvider__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5547);






var previousPathName = "";
var MatomoUserTracking = function() {
    var config = (0,_providers_ConfigContextProvider__WEBPACK_IMPORTED_MODULE_4__/* .useConfigContext */ .q)();
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var prepareTrackView = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(path) {
        if (config.matomoTrackingUrl && config.matomoTrackingId && "object" !== "undefined" && window._paq) {
            var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(path.split("?"), 1), pathname = ref[0];
            if (previousPathName) {
                window._paq.push([
                    "setReferrerUrl",
                    "".concat(previousPathName)
                ]);
            }
            window._paq.push([
                "setCustomUrl",
                pathname
            ]);
            window._paq.push([
                "deleteCustomVariables",
                "page"
            ]);
            previousPathName = pathname;
        }
    }, [
        config.matomoTrackingUrl,
        config.matomoTrackingId
    ]);
    var trackView = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(path) {
        if (config.matomoTrackingUrl && config.matomoTrackingId && "object" !== "undefined" && window._paq) {
            setTimeout(function() {
                var doTrackUrl = true;
                if (path.indexOf("?") > -1) {
                    var pathName = path.split("?")[0];
                    if (pathName === previousPathName) {
                        doTrackUrl = false;
                    } else {
                        previousPathName = pathName;
                    }
                } else {
                    previousPathName = path;
                }
                if (doTrackUrl) {
                    window._paq.push([
                        "setDocumentTitle",
                        document.title
                    ]);
                    window._paq.push([
                        "trackPageView"
                    ]);
                }
            }, 0);
        }
    }, [
        config.matomoTrackingUrl,
        config.matomoTrackingId
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (false) {}
        router.events.on("routeChangeStart", prepareTrackView);
        router.events.on("routeChangeComplete", trackView);
        previousPathName = document.location.pathname;
        return function() {
            router.events.off("routeChangeStart", prepareTrackView);
            router.events.off("routeChangeComplete", trackView);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: config.matomoTrackingUrl && config.matomoTrackingId && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_2___default()), {
                    id: "tracking-code",
                    strategy: "afterInteractive",
                    children: "\n              if (typeof window !== \"undefined\") {\n                const _paq = window._paq = window._paq || [];\n                _paq.push(['trackPageView']);\n                _paq.push(['enableLinkTracking']);\n                _paq.push(['setTrackerUrl', '".concat(config.matomoTrackingUrl, "/matomo.php']);\n                _paq.push(['setSiteId', '").concat(config.matomoTrackingId, "']);\n              }\n            ")
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_2___default()), {
                    strategy: "afterInteractive",
                    src: "".concat(config.matomoTrackingUrl, "/matomo.js")
                })
            ]
        })
    });
};


/***/ }),

/***/ 240:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ Menu; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(9521);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3279);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_debounce__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_focus_lock__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(3980);
/* harmony import */ var _components_state_MainMenuState__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(729);
/* harmony import */ var _Menus_MenuFooter__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2756);
/* harmony import */ var _Logo__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7963);
/* harmony import */ var _ui_LabElement__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7656);
/* harmony import */ var _ui_StaticSvgs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1675);
/* harmony import */ var _providers_ConfigContextProvider__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(5547);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _components_state_CssVarsState__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(9479);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: var(--text-body-font-size);\n  line-height: var(--text-body-line-height);\n  position: fixed;\n  z-index: ",
        ";\n  top: 0px;\n  width: 100vw;\n\n  background-color: var(--color-ailab-red);\n  color: white;\n\n  transform: translateX(-105%);\n  opacity: 0;\n  transition: opacity ",
        "ms;\n  overflow: hidden;\n\n  & a {\n    text-decoration: none;\n  }\n  & *::selection {\n    background: var(--color-bg, #fff);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 100%;\n  width: 100%;\n  position: relative;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 100%;\n  width: 100%;\n  overflow: auto;\n  overscroll-behavior: contain;\n  position: sticky;\n  top: 0;\n  left: 0;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  min-height: 100%;\n  display: flex;\n  flex-direction: column;\n  grid-gap: var(--size-gutter-width);\n  padding: var(--size-5);\n\n  ",
        " {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    grid-template-rows: auto;\n    align-items: stretch;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: #fff;\n  display: flex;\n  flex-direction: column;\n  grid-gap: var(--size-4);\n\n  ",
        " {\n    justify-content: ",
        ";\n  }\n\n  & header {\n    ",
        ";\n    font-size: 1.5em;\n    color: white;\n    font-weight: 700;\n    height: 2.4em;\n\n    display: flex;\n    align-items: center;\n    margin-bottom: var(--size-4);\n\n    .logo {\n      margin-right: 20px;\n    }\n  }\n\n  &.piai {\n    section {\n      margin-bottom: auto;\n\n      h1 {\n        color: white;\n        font-size: 1.5em;\n        font-weight: 700;\n      }\n\n      p {\n        ",
        " {\n          max-width: 80%;\n        }\n      }\n\n      & a {\n        padding-top: 20px;\n        padding-bottom: 0;\n        display: block;\n        ",
        "\n        color: white;\n        font-weight: 700;\n        font-size: 0.9em;\n\n        opacity: 1;\n\n        &:hover {\n          opacity: 0.7;\n        }\n\n        svg {\n          height: 0.8em;\n          position: relative;\n          width: auto;\n          top: 0.02em;\n\n          path {\n            fill: white;\n          }\n        }\n      }\n    }\n\n    nav {\n      gap: 0;\n\n      a {\n        color: white;\n        font-size: 1em;\n        padding: 5px 0;\n        text-transform: none;\n      }\n    }\n  }\n\n  &.toolbox {\n    color: white;\n\n    section.tool > a {\n      display: flex;\n      color: white;\n      margin-bottom: var(--size-2);\n\n      .labElement {\n        float: left;\n        margin: 0 10px 0 0;\n      }\n\n      .labElement + span {\n        margin: auto 0;\n        padding-bottom: 5px;\n      }\n    }\n\n    section.tool nav {\n      display: flex;\n      flex-direction: column;\n      padding: 0;\n\n      a {\n        color: white;\n        font-size: 0.8em;\n        padding: 5px 0;\n      }\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}













var ANIMATION_LENGTH = 500;
var MenuContainer = styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"].div.attrs */ .ZP.div.attrs(function(props) {
    return {
        style: {
            // as the menu transition was visible on page load, the transform has to be set as style attribute
            // apparently classes are set dynamically and do not reliably intitialize elements
            transform: props.isOpen || props.isAnimating ? "none" : "translateX(-105%)",
            opacity: props.isOpen ? 1 : 0,
            pointerEvents: !props.isOpen ? "none" : undefined
        }
    };
}).withConfig({
    componentId: "sc-b320e4ee-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.zIndex.menu;
}, ANIMATION_LENGTH);
var MenuWrapper = styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-b320e4ee-1"
})(_templateObject1());
var MenuContent = styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-b320e4ee-2"
})(_templateObject2());
var MenuContentGrid = styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-b320e4ee-3"
})(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.tabletLandscape;
});
var Column = styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-b320e4ee-4"
})(_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.tabletLandscape;
}, function(props) {
    return props.stretch ? "space-between" : "flex-start";
}, function(param) {
    var theme = param.theme;
    return theme.applyMixin("uppercase");
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.tabletLandscape;
}, function(param) {
    var theme = param.theme;
    return theme.applyMixin("uppercase");
});
var Menu = function() {
    var config = (0,_providers_ConfigContextProvider__WEBPACK_IMPORTED_MODULE_9__/* .useConfigContext */ .q)();
    var mainMenuOpen = (0,_components_state_MainMenuState__WEBPACK_IMPORTED_MODULE_4__/* .useMainMenuStateIsOpenState */ .dB)();
    var mainMenuActions = (0,_components_state_MainMenuState__WEBPACK_IMPORTED_MODULE_4__/* .useMainMenuActions */ .iv)();
    var menuContainerRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)();
    var menuContentRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)();
    var isAnimatingRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(false);
    var isAnimatingTimeoutRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var isMobileLandscape = (0,_components_state_CssVarsState__WEBPACK_IMPORTED_MODULE_11__/* .useCssVarsStateIsMobileLandscapeState */ .KD)();
    var isTabletAndUp = (0,_components_state_CssVarsState__WEBPACK_IMPORTED_MODULE_11__/* .useCssVarsStateIsTabletAndUpState */ .kH)();
    var onResize = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        if (menuContainerRef.current) menuContainerRef.current.style.height = "".concat(window.innerHeight + 200, "px");
        if (menuContentRef.current) menuContentRef.current.style.height = "".concat(window.innerHeight, "px");
    }, []);
    var onResizeDebounced = lodash_debounce__WEBPACK_IMPORTED_MODULE_3___default()(onResize, 100);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (false) {}
        window.addEventListener("resize", onResizeDebounced);
        onResize();
        var triggerOnResize = function() {
            onResize();
        };
        document.addEventListener("DOMContentLoaded", triggerOnResize);
        return function() {
            window.removeEventListener("resize", onResizeDebounced);
            document.removeEventListener("DOMContentLoaded", triggerOnResize);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (isAnimatingTimeoutRef.current) clearTimeout(isAnimatingTimeoutRef.current);
        // as the useState function get's only called on the next render
        // a short delay lets the navigation flicker on open
        // using a ref does avoid this.
        isAnimatingRef.current = true;
        isAnimatingTimeoutRef.current = setTimeout(function() {
            isAnimatingRef.current = false;
            isAnimatingTimeoutRef.current = null;
        }, ANIMATION_LENGTH);
    }, [
        mainMenuOpen
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_focus_lock__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .ZP, {
        disabled: !mainMenuOpen,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(MenuContainer, {
            ref: menuContainerRef,
            isOpen: mainMenuOpen,
            isAnimating: isAnimatingRef.current,
            id: "menu",
            "aria-hidden": !mainMenuOpen,
            role: "menu",
            tabIndex: !mainMenuOpen ? -1 : undefined,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(MenuWrapper, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(MenuContent, {
                    ref: menuContentRef,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(MenuContentGrid, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Column, {
                                className: "piai",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("header", {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Logo__WEBPACK_IMPORTED_MODULE_6__/* .Logo */ .T, {
                                                color: "white",
                                                hoverColor: "white",
                                                size: 1
                                            }),
                                            (isTabletAndUp || isMobileLandscape) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                children: "Public interest AI"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("section", {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h1", {
                                                children: menuContent.piai.headline
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                                children: menuContent.piai.description
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("a", {
                                                href: menuContent.piai.linkURL,
                                                onClick: function() {
                                                    return mainMenuActions.close();
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_ui_StaticSvgs__WEBPACK_IMPORTED_MODULE_8__/* .Chevron */ .Tt, {}),
                                                    " ",
                                                    menuContent.piai.linkText
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Menus_MenuFooter__WEBPACK_IMPORTED_MODULE_5__/* .MenuFooter */ .d, {
                                        id: "footer",
                                        direction: "column"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Column, {
                                className: "toolbox",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("header", {
                                        children: "Tools"
                                    }),
                                    config.tools.map(function(tool, index) {
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("section", {
                                            className: "tool",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_10___default()), {
                                                    href: "/tool/".concat(tool.slug),
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("a", {
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_ui_LabElement__WEBPACK_IMPORTED_MODULE_7__/* .LabElement */ .c, {
                                                                shortHandle: tool.iconShort,
                                                                longText: tool.iconLong,
                                                                color: "#fff",
                                                                hoverColor: tool.colorHighlight,
                                                                size: 1.6
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                                children: tool.name
                                                            })
                                                        ]
                                                    })
                                                }, "tool-".concat(index)),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("nav", {
                                                    children: tool.menu.map(function(menuItem, i) {
                                                        if (menuItem === null || menuItem === void 0 ? void 0 : menuItem.url) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                                            href: menuItem.url,
                                                            target: menuItem.target,
                                                            rel: "noreferrer",
                                                            children: menuItem.name
                                                        }, "tool-".concat(index, "-menu-").concat(i));
                                                        var _slug;
                                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_10___default()), {
                                                            href: "/tool/".concat(tool.slug, "/").concat((_slug = menuItem.slug) !== null && _slug !== void 0 ? _slug : ""),
                                                            children: menuItem.name
                                                        }, "tool-".concat(index, "-menu-").concat(i));
                                                    })
                                                })
                                            ]
                                        }, "tool-".concat(index));
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        })
    });
};
var menuContent = {
    piai: {
        headline: "What is Public Interest AI?",
        description: "Defining public interest AI is as difficult as it is crucial for our society. Academia and various societal stakeholder have entered a discourse to sharpen the edges of this explanation.",
        linkText: "Explore the definition",
        linkURL: "/#!more"
    }
};


/***/ }),

/***/ 3063:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ MenuButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9521);
/* harmony import */ var _components_state_MainMenuState__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(729);
/* harmony import */ var _ui_SvgBackground__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: fixed;\n  z-index: ",
        ";\n\n  top: ",
        ";\n\n  ",
        " {\n    top: ",
        ";\n  }\n\n  right: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: none;\n  background: none;\n  cursor: pointer;\n  padding: 0;\n  position: relative;\n  opacity: 1;\n\n  & > span {\n    transition: opacity 0.3s;\n    position: absolute;\n    top: 0;\n    left: 0;\n  }\n\n  height: var(--size-5);\n  width: var(--size-5);\n\n  ",
        " {\n    height: var(--size-4);\n    width: var(--size-4);\n  }\n\n  &:active,\n  &:focus-within {\n    & > span {\n      opacity: 0.6;\n    }\n  }\n\n  @media (any-pointer: fine) {\n    &:hover {\n      & > span {\n        opacity: 0.6;\n      }\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var MenuButtonContainer = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-5a9042de-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.zIndex.menu + 1;
}, function(param) {
    var theme = param.theme;
    return theme.colorMode === "dark" ? "var(--size-3)" : "calc(var(--size-4) + 10px)";
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.tablet;
}, function(param) {
    var theme = param.theme;
    return theme.colorMode === "dark" ? "calc(var(--size-3) + 4px)" : "calc(var(--size-4) + 10px)";
}, function(param) {
    var theme = param.theme;
    return theme.colorMode === "dark" ? "var(--size-3)" : "var(--size-4)";
});
var StyledMenuButton = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-5a9042de-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.tablet;
});
var MenuButton = function() {
    var isMainMenuOpen = (0,_components_state_MainMenuState__WEBPACK_IMPORTED_MODULE_3__/* .useMainMenuStateIsOpenState */ .dB)();
    var mainMenuActions = (0,_components_state_MainMenuState__WEBPACK_IMPORTED_MODULE_3__/* .useMainMenuActions */ .iv)();
    var theme = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(styled_components__WEBPACK_IMPORTED_MODULE_5__/* .ThemeContext */ .Ni);
    var menuButtonRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(MenuButtonContainer, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledMenuButton, {
            ref: menuButtonRef,
            "aria-expanded": isMainMenuOpen,
            "aria-label": "".concat(isMainMenuOpen ? "close" : "open", " menu"),
            "aria-controls": "menu",
            onClick: function(event) {
                event.preventDefault();
                if (isMainMenuOpen) {
                    mainMenuActions.close();
                } else {
                    mainMenuActions.open(menuButtonRef);
                }
                event.currentTarget.blur();
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_ui_SvgBackground__WEBPACK_IMPORTED_MODULE_4__/* .SvgBackground */ .K, {
                className: "svg open",
                type: isMainMenuOpen ? "close" : theme.colorMode === "dark" ? "menuNeg" : "menu",
                position: "left center",
                width: "100%",
                height: "100%"
            })
        })
    });
};


/***/ }),

/***/ 2756:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "d": function() { return /* binding */ MenuFooter; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9521);
// EXTERNAL MODULE: ./providers/SettingsContextProvider.tsx
var SettingsContextProvider = __webpack_require__(7182);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./utils/sanitize.ts
var sanitize = __webpack_require__(2938);
;// CONCATENATED MODULE: ./components/app/Menus/MenuItem.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-transform: uppercase;\n  display: inline-block;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var A = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-991be1b3-0"
})(_templateObject());
var MenuItem = function(param) {
    var item = param.item, target = param.target, rel = param.rel, onClick = param.onClick;
    var ref, ref1, ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: (ref = item === null || item === void 0 ? void 0 : item.url) !== null && ref !== void 0 ? ref : "",
            passHref: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(A, {
                title: (item === null || item === void 0 ? void 0 : item.attr_title) !== (item === null || item === void 0 ? void 0 : item.title) ? item === null || item === void 0 ? void 0 : item.attr_title : undefined,
                target: (ref1 = target !== null && target !== void 0 ? target : item === null || item === void 0 ? void 0 : item.target) !== null && ref1 !== void 0 ? ref1 : undefined,
                rel: (ref2 = rel !== null && rel !== void 0 ? rel : item === null || item === void 0 ? void 0 : item.xfn) !== null && ref2 !== void 0 ? ref2 : undefined,
                className: (item === null || item === void 0 ? void 0 : item.active) ? "menu-link-active" : undefined,
                onClick: onClick,
                dangerouslySetInnerHTML: {
                    __html: (0,sanitize/* default */.Z)(item === null || item === void 0 ? void 0 : item.title)
                }
            })
        })
    });
};

;// CONCATENATED MODULE: ./components/app/Menus/MenuFooter.tsx

function MenuFooter_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: ",
        ";\n\n  gap: var(--size-gutter-width);\n  ",
        ";\n"
    ]);
    MenuFooter_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var Nav = styled_components_browser_esm/* default.nav.withConfig */.ZP.nav.withConfig({
    componentId: "sc-bc59e58c-0"
})(MenuFooter_templateObject(), function(param) {
    var direction = param.direction;
    return direction;
}, function(param) {
    var theme = param.theme;
    return theme.textStyle("small");
});
var MenuFooter = function(param) {
    var id = param.id, direction = param.direction;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
    var settings = (0,SettingsContextProvider/* useSettingsContext */.K)();
    var ref11;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Nav, {
        direction: direction,
        children: [
            !(settings === null || settings === void 0 ? void 0 : (ref = settings.menus) === null || ref === void 0 ? void 0 : (ref1 = ref.footer) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.items) === null || ref2 === void 0 ? void 0 : ref2.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                children: [
                    'No menu items in menu "',
                    (ref11 = settings === null || settings === void 0 ? void 0 : (ref3 = settings.menus) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.footer) === null || ref4 === void 0 ? void 0 : ref4.name) !== null && ref11 !== void 0 ? ref11 : id,
                    '" added'
                ]
            }),
            (settings === null || settings === void 0 ? void 0 : (ref5 = settings.menus) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.footer) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.items) === null || ref7 === void 0 ? void 0 : ref7.length) > 0 && (settings === null || settings === void 0 ? void 0 : (ref8 = settings.menus) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.footer) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.items) === null || ref10 === void 0 ? void 0 : ref10.map(function(item, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem, {
                    item: item
                }, "".concat(id, "-").concat(index));
            }))
        ]
    });
};


/***/ }),

/***/ 4321:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ LoadingBar; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  0% {\n    width: 0%;\n    left: 0px;\n    right: auto;\n  }\n  49.99% {\n    width: 100%;\n    left: 0px;\n    right: auto;\n  }\n  50% {\n    width: 100%;\n    left: auto;\n    right: 0px;\n  }\n  99.99% {\n    width: 0%;\n    left: auto;\n    right: 0px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n          ",
        " 2s infinite\n        "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: fixed;\n  height: 3px;\n  top: 0;\n  left: 0;\n  width: 100%;\n  z-index: ",
        ";\n  animation: ",
        ";\n  background-color: ",
        ";\n  pointer-events: none;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var loadingBorderAnimation = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .keyframes */ .F4)(_templateObject());
var LoadingBar = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-bfbba455-0"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.zIndex.overlay;
}, function(param) {
    var isLoading = param.isLoading;
    return isLoading ? (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject1(), loadingBorderAnimation) : "none";
}, function(param) {
    var isLoading = param.isLoading, bgColor = param.bgColor;
    return isLoading ? bgColor !== null && bgColor !== void 0 ? bgColor : "var(--color-loading-bar)" : "transparent";
});


/***/ }),

/***/ 2041:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export SvgCloseNeg */
var SvgCloseNeg = '%3Csvg%20xmlns%3D"http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg"%20width%3D"76.296"%20height%3D"50.296"%3E%3Cpath%20fill%3D"none"%20stroke%3D"%23fff"%20stroke-linecap%3D"round"%20stroke-width%3D"6"%20d%3D"m14.148%2010.914%2032.181%2032.181M14.148%2043.381%2046.329%2011.2"%2F%3E%3C%2Fsvg%3E';
/* harmony default export */ __webpack_exports__["C"] = (SvgCloseNeg);


/***/ }),

/***/ 1257:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ AspectRatio; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3279);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_debounce__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  width: ",
        ";\n  height: ",
        ";\n  aspect-ratio: ",
        ";\n  overflow: hidden;\n  background-color: ",
        ";\n  transform: translateZ(0);\n  & > div,\n  & img,\n  & video,\n  & iframe {\n    width: 100%;\n    height: 100%;\n    object-fit: ",
        ";\n    object-position: ",
        ";\n    border: none;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var uA = typeof navigator !== "undefined" ? navigator.userAgent.toLowerCase() : "";
var isChrome = uA.indexOf("chrome") !== -1;
var isSafari = (uA.indexOf("safari") !== -1 || uA.indexOf("applewebkit") !== -1 || uA.indexOf("ipad") !== -1 || uA.indexOf("iphone") !== -1) && !isChrome;
/*
  One coutl also use  potentially use 
  @supports not (aspect-ratio: 16 / 9) {
    ...
  }
*/ var Aspect = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-31a0255b-0"
})(_templateObject(), function(param) {
    var aRwidth = param.aRwidth;
    return aRwidth;
}, function(param) {
    var aRheight = param.aRheight;
    return aRheight;
}, function(param) {
    var useAspectRatio = param.useAspectRatio, aRatio = param.aRatio;
    return useAspectRatio ? aRatio : "auto";
}, function(param) {
    var bgColor = param.bgColor;
    return bgColor !== null && bgColor !== void 0 ? bgColor : "transparen";
}, function(param) {
    var objectFit = param.objectFit;
    return objectFit;
}, function(param) {
    var objectPosition = param.objectPosition;
    return objectPosition;
});
var AspectRatio = function(param) {
    var ratio = param.ratio, _mode = param.mode, mode = _mode === void 0 ? "constrain" : _mode, _objectFit = param.objectFit, objectFit = _objectFit === void 0 ? "fill" : _objectFit, _objectPosition = param.objectPosition, objectPosition = _objectPosition === void 0 ? "center center" : _objectPosition, children = param.children, _direction = param.direction, direction = _direction === void 0 ? "width" : _direction, bgColor = param.bgColor, className = param.className;
    var aspectContainerRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)();
    var onResize = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        if (mode === "fill" || !aspectContainerRef.current) return;
        if (aspectContainerRef.current) {
            if (direction === "width") {
                aspectContainerRef.current.style.height = "calc((1 / (".concat(ratio, ")) * ").concat(aspectContainerRef.current.offsetWidth.toFixed(3), "px)");
            } else {
                aspectContainerRef.current.style.width = "calc(((".concat(ratio, ") / 1) * ").concat(aspectContainerRef.current.offsetWidth.toFixed(3), "px)");
            }
        }
    }, [
        direction,
        ratio,
        mode
    ]);
    var onResizeDebounced = lodash_debounce__WEBPACK_IMPORTED_MODULE_3___default()(onResize, 250);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (false) {}
        var aRSupported = typeof CSS !== "undefined" && CSS.supports("aspect-ratio", "1/1");
        // Check on mount (callback is not called until a change occurs)
        if (mode === "constrain" && (!aRSupported || isSafari && ratio.replace(/ /ig, "") === "16/9")) {
            window.addEventListener("resize", onResizeDebounced);
            onResize();
            return function() {
                if (aRSupported) return;
                if (mode === "constrain" && !aRSupported) window.removeEventListener("resize", onResizeDebounced);
            };
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var aRwidth = mode === "fill" || direction === "width" ? "100%" : "auto";
    var aRheight = mode === "fill" || direction === "height" ? "100%" : "auto";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Aspect, {
        ref: aspectContainerRef,
        aRatio: ratio,
        bgColor: bgColor,
        aRheight: aRheight,
        aRwidth: aRwidth,
        objectFit: objectFit,
        objectPosition: objectPosition,
        useAspectRatio: !isSafari || isSafari && ratio.replace(/ /ig, "") !== "16/9",
        className: "aspect-ratio ".concat(className),
        children: children
    });
};


/***/ }),

/***/ 7656:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ LabElement; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9521);
/* harmony import */ var _AspectRatio__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1257);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-color: ",
        ";\n  color: ",
        ";\n  background-color: ",
        ";\n  \n  font-size: ",
        "em;\n  border-style: solid;\n  border-width: 0.16em;\n  padding: 0.2em;\n\n  // Resetting inherited styles from parent\n  text-transform: none;\n  font-weight: 300;\n  text-align: left;\n\n  width: 2.4em;\n  min-width: 2.4em;\n  max-width: 2.4em;\n  height: 2.4em;\n\n  display: flex;\n  flex-direction: column;\n  \n  \n\n  // & + &{\n  //   margin-left: 0.3em;\n  // }\n\n  transition: color var(--transition-speed-link),\n    border-color var(--transition-speed-link);\n\n  @media (any-pointer: fine) {\n    &:hover {\n      border-color: ",
        ";\n      color: ",
        ";\n    }\n  }\n\n  @media print {\n    border-color: #000;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 0.8em;\n  text-decoration: none;\n  font-weight: 800;\n  line-height: 1em;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 0.35em;\n  line-height: 1em;\n  text-decoration: none;\n\n  margin-top: auto;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




// import safeHtml from "~/utils/sanitize";
// import omit from "lodash/omit";
var ElementContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_AspectRatio__WEBPACK_IMPORTED_MODULE_3__/* .AspectRatio */ .o).withConfig({
    componentId: "sc-7183139e-0"
})(_templateObject(), function(param) {
    var color = param.color;
    return color || "#000";
}, function(param) {
    var color = param.color;
    return color || "#000";
}, function(param) {
    var theme = param.theme, bgColor = param.bgColor;
    return bgColor ? theme.color(bgColor, 0.8) : "transparent";
}, function(param) {
    var size = param.size;
    return size || 1;
}, function(param) {
    var hoverColor = param.hoverColor;
    return hoverColor || "#666";
}, function(param) {
    var hoverColor = param.hoverColor;
    return hoverColor || "#666";
});
var ElementShort = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-7183139e-1"
})(_templateObject1());
var ElementLong = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-7183139e-2"
})(_templateObject2());
var LabElement = function(param) {
    var color = param.color, hoverColor = param.hoverColor, shortHandle = param.shortHandle, longText = param.longText, size = param.size, bgColor = param.bgColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(ElementContainer, {
        ratio: "1",
        color: color,
        hoverColor: hoverColor,
        bgColor: bgColor,
        size: size,
        className: "labElement",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ElementShort, {
                children: shortHandle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ElementLong, {
                children: longText
            })
        ]
    });
};


/***/ }),

/***/ 1675:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Eh": function() { return /* binding */ Arrow; },
/* harmony export */   "M3": function() { return /* binding */ Borders; },
/* harmony export */   "RQ": function() { return /* binding */ Frame; },
/* harmony export */   "Tt": function() { return /* binding */ Chevron; },
/* harmony export */   "ho": function() { return /* binding */ BoxSvgs; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);


// ONLINE PATH EDITOR: 
// https://yqnn.github.io/svg-path-editor/
var Borders = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        viewBox: "10 -5 300 610",
        preserveAspectRatio: "none",
        className: "frame",
        vectorEffect: "non-scaling-stroke",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
            id: "Borders",
            "data-name": "Borders",
            transform: "translate(0) scale(1 1)",
            strokeWidth: "1px",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M 0 0 c 0 0 77 -2 111 0 c 22 1 43 2 69 2 c 38 1 107 -1 197 -2 l 0 600 c -14 2 -89 3 -150 0 c -60 -1 -88 0 -150 0 L 0 600 Z"
            })
        })
    });
};
var Arrow = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "33.055",
        height: "79.144",
        viewBox: "0 0 33.055 79.144",
        className: "arrow",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
            id: "arrow_bow_right",
            "data-name": "arrow bow right",
            transform: "translate(-1215.249 -897.786) rotate(12)",
            strokeWidth: 1,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    id: "Path_64",
                    "data-name": "Path 64",
                    d: "M-997.036,639.267s3.227,18.16,6.8,31.988c2.758,13.612,10.359,41.468,10.359,41.468",
                    transform: "translate(2387.864 -16.862)",
                    fill: "none",
                    stroke: "#707070"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    id: "Path_65",
                    "data-name": "Path 65",
                    d: "M-1016.623,685.855l-5.774,17.292-16.924-6.707",
                    transform: "translate(2562.47 241.007) rotate(13)",
                    fill: "none",
                    stroke: "#707070",
                    strokeLinecap: "round"
                })
            ]
        })
    });
};
var Frame = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        viewBox: "0 0 1505.006 549.168",
        preserveAspectRatio: "none",
        className: "frame",
        vectorEffect: "non-scaling-stroke",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
            id: "Frame",
            "data-name": "Frame",
            transform: "translate(16.006 1.026)",
            strokeWidth: "1px",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M 166.054 -0.0267 C 87.6825 -0.0267 9.6461 0.5786 0.8275 0.6491 C 0.0558 4.7288 -3.4991 24.1671 -7.0133 53.9455 C -9.3336 73.6097 -11.1826 93.8685 -12.5087 114.1591 C -14.1659 139.5205 -15.0062 165.0031 -15.0062 189.8993 C -15.0062 218.5709 -13.9087 248.0349 -11.6505 279.9753 C -9.6869 307.7517 -7.1267 333.4631 -4.8677 356.1479 C -1.7192 387.7667 0.9999 415.0735 0.9999 436.7287 L 0.9999 544.9168 C 8.6575 545.0738 60.6987 546.0745 141.549 546.0745 C 192.8174 546.0745 245.459 545.6781 298.0117 544.8963 C 367.7106 543.8591 444.9175 542.1357 526.6577 540.3111 C 667.6089 537.1649 813.3589 533.9115 934.5375 533.9115 C 1019.1565 533.9115 1100.6917 534.4889 1176.8783 535.6279 C 1237.8285 536.5391 1295.5117 537.8097 1348.3256 539.4043 C 1430.4445 541.8837 1475.2615 544.3929 1482.7666 544.8309 C 1482.4468 539.5594 1481.0768 516.1115 1479.7223 479.9885 C 1478.8185 455.8833 1478.0985 430.9325 1477.5819 405.8287 C 1476.9365 374.4495 1476.6091 342.7415 1476.6091 311.5859 C 1476.6091 303.2359 1476.5665 293.2483 1476.5214 282.6741 C 1476.251 219.2589 1475.8422 123.4251 1482.855 89.5005 C 1485.4911 76.7465 1487.1332 64.1039 1487.7357 51.9239 C 1488.2178 42.1805 1488.0393 32.7095 1487.2056 23.7737 C 1486.0144 11.0096 1483.8036 2.9751 1483.1055 0.6686 L 909.0217 10.7183 L 908.9971 10.7175 L 593.5579 0.6567 C 592.3557 0.7356 569.5788 2.2231 540.4005 3.6919 C 490.5067 6.2035 460.5739 6.7307 444.2491 6.7307 C 417.3861 6.7307 401.9513 5.7513 382.4102 4.5115 C 361.0555 3.1567 334.4789 1.4703 282.6935 0.6555 C 253.9233 0.2029 214.6802 -0.0267 166.054 -0.0267 Z"
            })
        })
    });
};
var BoxSvgs = function(param) {
    var i = param.i;
    switch(i){
        case 1:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "100%",
                height: "100%",
                viewBox: "-3 0 286.921 277.991",
                className: "box",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                    id: "Square1",
                    "data-name": "Square1",
                    transform: "translate(5.96)",
                    fill: "#fff",
                    stroke: "var(--color-grey)",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M0,0S20.611,4.539,55.825,6.165,108.432,0,164.286,0H276s2.162,17.519,0,46.652c-.926,12.475-12.722,33.364-5.96,53.921,4.236,12.878,0,34.736,0,46.356,0,70.75,6.921,123.219,6.921,123.219s-22.22,7.842-91.22,7.842c-35.535,0-85.969-9.311-121.416-7.842-33.151,1.374-70.286,0-70.286,0S.961,298.753.961,228c0-27.309-6.921-92.917-6.921-149.528S0,0,0,0Z"
                    })
                })
            });
        case 2:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "282.921",
                height: "285.218",
                viewBox: "0 0 282.921 286.218",
                className: "box",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                    id: "Square2",
                    "data-name": "Square2",
                    transform: "translate(5.96 0.723)",
                    fill: "none",
                    stroke: "var(--color-grey)",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M0,0S17.371-1.626,52.585,0s42.522,0,98.376,0H276s2.162,17.519,0,46.652c-1.523,20.518-1.039,63.352-1.039,93,0,70.75,2,130.5,2,130.5H173.341c-35.535,0-82.46,11.382-117.907,12.851C22.284,284.374,0,283,0,283s.961,15.753.961-55c0-27.309-6.921-92.917-6.921-149.528S0,0,0,0Z"
                    })
                })
            });
        case 3:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "282.921",
                height: "285.218",
                viewBox: "0 -3 286.921 289.218",
                className: "box",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                    id: "Square3",
                    "data-name": "Square3",
                    transform: "translate(5.96 -1.723)",
                    fill: "none",
                    stroke: "var(--color-grey)",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M0,0S17.371-1.626,52.585,0,85,6.5,140.858,6.5,276,0,276,0s2.162,17.519,0,46.652c-1.523,20.518.961,59.717.961,89.361C276.961,206.763,276,283,276,283s-32.831,3.9-101.831,3.9c-35.535,0-83.288-5.373-118.735-3.9C22.284,284.374,0,283,0,283s.961,15.753.961-55c0-27.309-6.921-92.917-6.921-149.528S0,0,0,0Z"
                    })
                })
            });
        case 4:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "282.921",
                height: "285.218",
                viewBox: "0 0 282.921 285.218",
                className: "box",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                    id: "Square4",
                    "data-name": "Square4",
                    transform: "translate(5.96 0.723)",
                    fill: "none",
                    stroke: "var(--color-grey)",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M 0 1 H 52.585 S 287.792 14.979 282.078 3.6 S 278.162 17.519 276 46.652 C 274.477 67.17 268.432 94.032 268.432 123.676 C 268.432 194.427 276 283 276 283 S 242.828 277.309 173.828 277.309 C 138.293 277.309 90.881 281.531 55.434 283 C 22.284 284.374 0 283 0 283 V 226.442 C 0 199.133 0 140 0 104 C -0.3333 70 -6 42 0 0 Z"
                    })
                })
            });
        default:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "282.921",
                height: "285.218",
                viewBox: "0 0 282.921 285.218",
                className: "box",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                    id: "Square5",
                    "data-name": "Square5",
                    transform: "translate(5.96 0.723)",
                    fill: "none",
                    stroke: "var(--color-grey)",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M0,0H52.585a69.833,69.833,0,0,0,20,3.181C83.229,3.181,95.154,0,95.154,0H276s2.162,17.519,0,46.652c-1.523,20.518-7.568,47.38-7.568,77.024C268.432,194.427,276,283,276,283s-33.172-5.691-102.172-5.691c-35.535,0-82.947,4.222-118.394,5.691C22.284,284.374,0,283,0,283V226.442c0-27.309,7.342-106.174,7.342-106.174Z"
                    })
                })
            });
    }
};
var Chevron = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        // width="9.333"
        // height="14.883"
        viewBox: "0 0 9.333 14.883",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            id: "back",
            d: "M7.855.857,15.333,8.4,12.7,11.1,7.855,15.74,6,13.926,11.688,8.4,6,2.711Z",
            transform: "translate(-6 -0.857)"
        })
    });
};


/***/ }),

/***/ 1147:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "K": function() { return /* binding */ SvgBackground; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./components/svgs/SvgMenuRounded.ts
var SvgMenuRounded = '%3Csvg%20xmlns%3D"http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg"%20width%3D"51.296"%20height%3D"38.296"%3E%3Cdefs%3E%3CclipPath%20id%3D"a"%3E%3Cpath%20fill%3D"none"%20d%3D"M0%200h51.296v38.296H0z"%2F%3E%3C%2FclipPath%3E%3C%2Fdefs%3E%3Cg%20clip-path%3D"url(%23a)"%3E%3Cpath%20fill%3D"none"%20stroke%3D"%23666"%20stroke-linecap%3D"round"%20stroke-width%3D"6"%20d%3D"M3.148%203.148h45M3.148%2019.148h45M3.148%2035.148h45"%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E';
/* harmony default export */ var svgs_SvgMenuRounded = (SvgMenuRounded);

;// CONCATENATED MODULE: ./components/svgs/SvgMenuNeg.ts
var SvgMenuNeg = '%3Csvg%20xmlns%3D"http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg"%20width%3D"76.296"%20height%3D"50.296"%3E%3Cdefs%3E%3CclipPath%20id%3D"a"%3E%3Cpath%20fill%3D"none"%20d%3D"M0%200h76.296v50.296H0z"%2F%3E%3C%2FclipPath%3E%3C%2Fdefs%3E%3Cg%20clip-path%3D"url(%23a)"%3E%3Cpath%20fill%3D"none"%20stroke%3D"%23fff"%20stroke-linecap%3D"round"%20stroke-width%3D"6"%20d%3D"M10.148%2011.148h40M10.148%2027.148h40M10.148%2043.148h40M10.148%2059.148h40"%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E';
/* harmony default export */ var svgs_SvgMenuNeg = (SvgMenuNeg);

// EXTERNAL MODULE: ./components/svgs/SvgCloseNeg.ts
var SvgCloseNeg = __webpack_require__(2041);
;// CONCATENATED MODULE: ./components/svgs/SvgRightArrow.ts
var SvgRightArrow = '%3Csvg%20xmlns%3D"http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg"%20viewBox%3D"0%200%2033%2030"%3E%3Cpath%20d%3D"M18.09%2029.83%2033%2015%2018.11.16h-3.26l13.67%2013.55H0v2.52h28.52l-13.68%2013.6Z"%2F%3E%3C%2Fsvg%3E';
/* harmony default export */ var svgs_SvgRightArrow = (SvgRightArrow);

;// CONCATENATED MODULE: ./components/svgs/SvgPIAI.ts
var SvgPIAI = '%3Csvg%20xmlns%3D"http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg"%20width%3D"272.028"%20height%3D"130"%3E%3Cpath%20fill%3D"none"%20d%3D"M0%200h112.258v116.828H0Z"%20style%3D"mix-blend-mode%3Ahard-light%3Bisolation%3Aisolate"%20transform%3D"translate(7.125%206.819)"%2F%3E%3Ctext%20fill%3D"%23fff"%20font-family%3D"PTSans-Regular%2C%20PT%20Sans"%20font-size%3D"20"%20transform%3D"translate(19.846%2083)"%3E%3Ctspan%20x%3D"0"%20y%3D"0"%3EPublic%3C%2Ftspan%3E%3Ctspan%20x%3D"0"%20y%3D"20"%3EInterest%3C%2Ftspan%3E%3C%2Ftext%3E%3Ctext%20fill%3D"%23fff"%20font-family%3D"PTSans-Bold%2C%20PT%20Sans"%20font-size%3D"41"%20font-weight%3D"700"%20transform%3D"translate(19.846%2052.97)"%3E%3Ctspan%20x%3D"0"%20y%3D"0"%3EPI%3C%2Ftspan%3E%3C%2Ftext%3E%3Cpath%20fill%3D"%23fff"%20d%3D"M127.166%20130H0V0h127.166ZM7.779%20122.048h111.608V7.952H7.779Z"%2F%3E%3Cpath%20fill%3D"none"%20d%3D"M0%200h112.258v116.828H0Z"%20style%3D"mix-blend-mode%3Ahard-light%3Bisolation%3Aisolate"%20transform%3D"translate(152.485%206.819)"%2F%3E%3Ctext%20fill%3D"%23fff"%20font-family%3D"PTSans-Regular%2C%20PT%20Sans"%20font-size%3D"19"%20transform%3D"translate(167.851%20103.087)"%3E%3Ctspan%20x%3D"0"%20y%3D"0"%3EAI%3C%2Ftspan%3E%3C%2Ftext%3E%3Ctext%20fill%3D"%23fff"%20font-family%3D"PTSans-Bold%2C%20PT%20Sans"%20font-size%3D"41"%20font-weight%3D"700"%20transform%3D"translate(164.464%2052.971)"%3E%3Ctspan%20x%3D"0"%20y%3D"0"%3EAI%3C%2Ftspan%3E%3C%2Ftext%3E%3Cpath%20fill%3D"%23fff"%20d%3D"M272.028%20130H144.862V0h127.166Zm-119.387-7.952h111.608V7.952H152.641Z"%2F%3E%3C%2Fsvg%3E';
/* harmony default export */ var svgs_SvgPIAI = (SvgPIAI);

;// CONCATENATED MODULE: ./components/svgs/SvgLanguage.ts
var SvgLanguage = '%3Csvg%20xmlns%3D"http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg"%20width%3D"22.123"%20height%3D"20.767"%3E%3Cg%20opacity%3D".6"%3E%3Cpath%20d%3D"M19.982%200H8.564v3.568h1.427V1.427h9.991a.674.674%200%200%201%20.714.714v7.85a.674.674%200%200%201-.714.714H10.7v5H6.922l-2.64%202.07V15.7H2.141a.674.674%200%200%201-.714-.714v-7.85a.674.674%200%200%201%20.714-.714h9.277V5H2.141A2.1%202.1%200%200%200%200%207.136v7.85a2.1%202.1%200%200%200%202.141%202.141h.714v3.64l4.5-3.64h4.781v-5h7.85a2.1%202.1%200%200%200%202.141-2.141V2.141A2.1%202.1%200%200%200%2019.982%200"%2F%3E%3Cpath%20d%3D"M2.997%2014.201H4.71l.428-1.142H7.35l.428%201.142h1.713L7.065%207.85H5.352Zm3.211-4.567.714%202.216H5.497ZM12.845%209.991a6.7%206.7%200%200%200%202.855-.714%206.96%206.96%200%200%200%202.855.714V8.564a4.9%204.9%200%200%201-1.5-.285%205.42%205.42%200%200%200%201.5-4v-.711h-2.142V2.141h-1.427v1.427h-2.141v1.428h4.21a3.59%203.59%200%200%201-1.356%202.569%204.2%204.2%200%200%201-1.142-1.5h-1.5a5.2%205.2%200%200%200%201.288%202.213%204.1%204.1%200%200%201-1.5.285z"%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E';
/* harmony default export */ var svgs_SvgLanguage = (SvgLanguage);

;// CONCATENATED MODULE: ./components/ui/SvgBackground.tsx










// use https://jakearchibald.github.io/svgomg/
// use https://yoksel.github.io/url-encoder/
var SvgBackground = function(param) {
    var type = param.type, _width = param.width, width = _width === void 0 ? "100%" : _width, _height = param.height, height = _height === void 0 ? "100%" : _height, _className = param.className, className = _className === void 0 ? "svg" : _className, _size = param.size, size = _size === void 0 ? "contain" : _size, _position = param.position, position = _position === void 0 ? "center center" : _position, style = param.style, svg = param.svg;
    var activeSvg = svg !== null && svg !== void 0 ? svg : svgs_SvgMenuRounded;
    switch(type){
        case "menu":
            activeSvg = svgs_SvgMenuRounded;
            break;
        case "menuNeg":
            activeSvg = svgs_SvgMenuNeg;
            break;
        case "close":
            activeSvg = SvgCloseNeg/* default */.C;
            break;
        case "rightArrow":
            activeSvg = svgs_SvgRightArrow;
            break;
        case "logo":
            activeSvg = svgs_SvgPIAI;
            break;
        case "language":
            activeSvg = svgs_SvgLanguage;
            break;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: className,
        style: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, style), {
            display: "block",
            width: width,
            height: height,
            backgroundPosition: position,
            backgroundRepeat: "no-repeat",
            backgroundSize: size,
            backgroundImage: "url('data:image/svg+xml,".concat(activeSvg, "')")
        })
    });
};


/***/ }),

/***/ 2938:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export safeHtml */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9396);
/* harmony import */ var xss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8924);
/* harmony import */ var xss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(xss__WEBPACK_IMPORTED_MODULE_0__);



var safeHtml = function(html) {
    return xss__WEBPACK_IMPORTED_MODULE_0___default()(html, {
        whiteList: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, (0,xss__WEBPACK_IMPORTED_MODULE_0__.getDefaultWhiteList)()), {
            iframe: [
                "allow",
                "allowfullscreen",
                "height",
                "loading",
                "referrerpolicy",
                "src",
                "width", 
            ]
        }),
        stripIgnoreTag: true,
        stripIgnoreTagBody: [
            "script"
        ],
        allowCommentTag: false
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (safeHtml);


/***/ })

}]);